// eslint-disable-next-line import/prefer-default-export
export const converObjectId = (oid) => ({
    $oid: oid,
})
